var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"viewOpenpayFail"}},[_c('big',[_c('i',{staticClass:"fa fa-times"})]),_vm._v(" "),_c('h1',[_vm._v("Ocurrió un error realizando el pago")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }